import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { getSessionRegistrationManagerClient } from 'lib/SplashSessionRegistrationManager';

const useSessionRegistrationAnalytics = ({ enabled, guestId, eventId }) => {
    const { sessionId } = useParams();
    const lastSessionId = useRef(null);
    const sessionRegistrationManagerClient = useRef(getSessionRegistrationManagerClient()).current;

    const constructPayload = (id) => ({
        event: parseInt(eventId, 10),
        guest: parseInt(guestId, 10),
        session: parseInt(id, 10),
    });

    const trackSessionLeave = (id) => sessionRegistrationManagerClient.postSessionLeave(constructPayload(id));
    const trackSessionJoin = (id) => sessionRegistrationManagerClient.postSessionJoin(constructPayload(id));

    useEffect(() => {
        if (enabled) {
            if (lastSessionId.current) {
                trackSessionLeave(lastSessionId.current);
            }

            if (sessionId) {
                trackSessionJoin(sessionId);
            }

            lastSessionId.current = sessionId;
        }
    }, [enabled, sessionId]);

    return { lastSessionId: lastSessionId.current, sessionId };
};

export default useSessionRegistrationAnalytics;
